<template>
    <van-popup v-model="show" get-container="#app" round @click-overlay="closePop">
        <div class="pop-outer">
            <div class="pop-header">
                <span style="margin-right: .3005rem;"></span>
                假期留宿详情
                <div class="close-btn" @click="closePop">
                    <van-icon name="cross" />
                </div>
            </div>
            <!-- 请假信息 -->
            <div class="leave_info">
                <div class="info_title">留宿信息</div>
                <div class="info_detail_item">
                    <span class="info_detail_label">留宿状态：</span>
                    <div class="info_detail_content">

                        <van-tag style="flex-shrink: 0;" plain type="success"
                            v-if="stayDetail.accommodateState == 1">已通过</van-tag>
                        <van-tag style="flex-shrink: 0;" plain type="primary"
                            v-if="stayDetail.accommodateState == 0">待审批</van-tag>
                        <van-tag style="flex-shrink: 0;" plain type="danger"
                            v-if="stayDetail.accommodateState == -1">已驳回</van-tag>
                        <van-tag style="flex-shrink: 0;" plain type="danger"
                            v-if="stayDetail.accommodateState == -2">已过期</van-tag>
                        <van-tag style="flex-shrink: 0;" plain type="danger"
                            v-if="stayDetail.accommodateState == -3">已作废</van-tag>

                    </div>
                </div>
                <div class="info_detail_item">
                    <span class="info_detail_label">开始时间：</span>
                    <div class="info_detail_content">{{ getDate(stayDetail.beginTime) }}</div>
                </div>
                <div class="info_detail_item">
                    <span class="info_detail_label">结束时间：</span>
                    <div class="info_detail_content">{{ getDate(stayDetail.endTime) }}</div>
                </div>
                <div class="info_detail_item">
                    <span class="info_detail_label">考勤时段</span>
                    <div class="info_detail_content">{{ stayDetail.attendanceTimeType }}</div>
                </div>
                <div class="info_detail_item">
                    <span class="info_detail_label">留宿原因：</span>
                    <div class="info_detail_content">{{ stayDetail.remark }}</div>
                </div>
                <div class="info_detail_item">
                    <span class="info_detail_label">申请时间：</span>
                    <div class="info_detail_content">{{ getDate(stayDetail.createdTime) }}</div>
                </div>
            </div>

            <!-- 请假审批详情 -->
            <div class="approval_detail" v-if="stayDetail.approvals && stayDetail.approvals.length">
                <div class="detail_title">留宿审批信息</div>
                <div class="approval_detail_item" v-for="(item, index) in stayDetail.approvals" :key="index">
                    <div class="detail_top">{{ getDate2(item.approvalDate) }}</div>
                    <div class="detail_bottom">{{ item.auditName }} 
                        <!-- {{stayDetail.accommodateState == -3 && index == stayDetail.approvals.length - 1 ? '留宿作废':'变更状态为留宿'  }} -->
                    
                       

                            <van-tag style="flex-shrink: 0;" plain type="danger"
                            v-if="stayDetail.accommodateState == -3 && index == stayDetail.approvals.length - 1">已作废</van-tag>

                            <van-tag style="flex-shrink: 0;" plain type="success"
                            v-else >已通过</van-tag>
                    
                    </div>
                </div>
            </div>

            <div class="pop-button">
                <div class="pop-button-cancel" @click="closePop">取消</div>
                <div style="width: 1rem"  v-if="stayDetail.accommodateState == 1 && isDuringDate(stayDetail.endTime) && isAllowToVoid(stayDetail)"></div>
                <div class="pop-button-confirm" @click="cancelLeave"
                    v-if="stayDetail.accommodateState == 1 && isDuringDate(stayDetail.endTime) && isAllowToVoid(stayDetail)">留宿作废</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            // 请假弹窗选择
            show: false,
            stayDetail: {}
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
        isAllowToVoid (data) {
            if (data.approvals && data.approvals.find(item => item.auditId == this.$store.state.userId)) {
                return true
            } else {
                return false
            }
        },
        open(data) {
           
            this.id = data.id
            this.getStayDetail()
        },

        // 是否作废
        isDuringDate(e) {
            if (moment().isBefore(e)) {
                return true;
            }
            return false;
        },
        // 获取时间的
        getDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm')
        },

        getDate2(date) {
            return moment(date).format('HH:mm MM-DD')
        },
        closePop() {
            this.show = false;
        },
        // 获取留宿详情
        async getStayDetail() {
            const { data, code, msg } = await this.$https.getDormAccommodateById({
                id: this.id
            })
            if (code == 200) {

                // 获取考勤时段
                data.attendanceTimeType = data.attendanceTimeType.split(',')
                let arr= []
                data.attendanceTimeType.forEach(item => {
                    arr.push(['','早离寝','午归寝','午离寝','晚归寝'][item])
                })
                data.attendanceTimeType = arr.join(',')
                this.stayDetail = data
                this.show = true;
            } else {
                this.$toast(msg)
            }
        },
        // 作废 
        cancelLeave() {
            this.$dialog
                .confirm({
                    title: '温馨提示',
                    message: '是否作废该条留宿记录？'
                })
                .then(() => {
                    this.stayToVoidConfirm();
                })
                .catch(() => { });
        },
        // 留宿记录 
        async stayToVoidConfirm() {
            const { code, data, msg } = await this.$https.dormAccommodateCancel({
                userId: this.$store.state.userId,
                leaveIds: [this.stayDetail.id],
                cancelLeaveInfo: ''
            });

            if (code == 200) {
                this.$toast('操作完成');
                this.$emit('refresh');
                this.show = false
                return;
            } else {
                this.$toast(msg);
            }
        },


    }
};
</script>

<style lang="scss" scoped>
@import url('./loading.scss');

.pop-outer {
    color: #333;
    padding: 0 1.2019rem;
    padding-bottom: 1.2019rem;
    width: 90vw;
    position: relative;
    font-size: 0.875rem;
    background: url('./popinfo-bg.png');
    background-size: 100% 100%;

    .pop-header {
        padding: 1rem 0 1.125rem 0;
        text-align: center;
        position: relative;
        font-size: 1rem;
        font-weight: bold;

        .close-btn {
            position: absolute;
            color: #999999;
            right: -0.5rem;
            top: 1rem;
            font-size: 1rem;
        }
    }

    // 请假详情
    .leave_info {
        .info_title {
            position: relative;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 700;
            font-size: .8413rem;
            color: #000000;
            line-height: 0px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            line-height: 1.1418rem;
            margin-bottom: .7212rem;
            padding-left: .601rem;

            &::before {
                content: '';
                border-radius: .601rem;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: .1803rem;
                height: .8413rem;
                background-color: #3775FF;
            }
        }

        .info_detail_item {
            margin-bottom: .6611rem;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            width: 100%;
            font-size: .8413rem;
            color: #999999;
            line-height: 1.1418rem;
            text-align: left;
            font-style: normal;
            display: flex;

            .info_detail_label {
                width: 24%;

            }

            .info_detail_content {
                width: 76%;
                word-wrap: break-word;
            }

        }
    }

    .approval_detail {
        .detail_title {
            position: relative;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 700;
            font-size: .8413rem;
            color: #000000;
            line-height: 0px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            line-height: 1.1418rem;
            margin-bottom: .7212rem;
            padding-left: .601rem;

            &::before {
                content: '';
                border-radius: .601rem;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: .1803rem;
                height: .8413rem;
                background-color: #3775FF;
            }
        }

        .approval_detail_item {
            margin-left: .4808rem;
            border-left: 1px dotted #3775FF;
            padding-left: 1.0817rem;
            position: relative;
            padding-bottom: .9615rem;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: .9615rem;
                height: .9615rem;
                background: url('./leave_detail_dateicon.png') no-repeat;

                transform: translateX(-50%);
            }

            &:last-child {
                border: none;
            }

            .detail_top {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .8413rem;
                color: #333333;
                line-height: 1.1418rem;
                text-align: left;
                font-style: normal;
                margin-bottom: .3606rem;
            }

            .detail_bottom {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: .7212rem;
                color: #666666;
                line-height: .9615rem;
                text-align: left;
                font-style: normal;
            }
        }
    }

    .pop-button {
        margin-top: 1rem;
        display: flex;



        .pop-button-cancel {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: .8413rem;
            color: #FFFFFF;
            line-height: 1.1418rem;
            text-align: center;
            padding: .4207rem;
            flex: 1;
            border-radius: .9615rem;
            color: #666;
            background-color: #F4F5F9;
        }

        .pop-button-confirm {
            flex: 1;
            background: #F5A20C;
            border-radius: .9615rem;
            padding: .4207rem;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: .8413rem;
            color: #FFFFFF;
            line-height: 1.1418rem;
            text-align: center;
            background-color: #F5A20C;
            color: #fff;
        }
    }
}
</style>